import { primaryEndpoint } from './askSite';

export async function requestAskAudio(text, signal) {
  const endpoint = process.env.VUE_APP_EXHIBITION_AUDIO_ENDPOINT || primaryEndpoint();
  if (!endpoint) throw new Error('audio_unavailable');
  let response = await fetch(`${endpoint}/ask-audio?stream=1`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text }),
    cache: 'no-store',
    signal,
  });
  if (response.ok && response.headers.get('content-type')?.includes('application/json')) {
    const data = await response.json();
    const url = new URL(data.path, endpoint);
    if (url.origin !== new URL(endpoint).origin || url.pathname !== '/ask-audio/stream') throw new Error('audio_unavailable');
    // The player consumes this body once and retains its local media buffer.
    response = await fetch(url.href, { cache: 'no-store', signal });
  }
  if (!response.ok || !response.headers.get('content-type')?.startsWith('audio/')) {
    await response.body?.cancel();
    throw new Error('audio_unavailable');
  }
  if (!response.body) throw new Error('audio_unavailable');
  return response;
}
